import keys from 'lodash/keys';

export const objectMap = (object, map) =>
  keys(object).reduce((result, key, index) => {
    const value = object[key];
    return map(result, key, value, index);
  }, {});
